












































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TableColumn } from '../../components/organisms/CommonTable.vue';
import { dayjs, MONTH_FORMAT } from '../../../src_server/common/momentExtends';
import { PaymentStudentService } from '../../biz/remote/PaymentStudentService';
import { PaymentStudentDTO } from '../../../src_server/entity/dto/PaymentStudentDTO';
import { Session } from '../../utils/Session';
import { URIs } from '../../../src_server/common/URIs';

@Component({
  filters: {
    currencyFormat: (num: number) => {
      return num.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
    },
  },
})
export default class PaymentStudentPage extends Vue {
  private termOfDate = dayjs().add(1, 'month').date(25).format('YYYY-MM-DD');

  private rows: PaymentStudentDTO[] = [];
  private target_month: string = dayjs().format(MONTH_FORMAT);
  private cols: TableColumn[] = [
    {
      label: '選択',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `<input type="checkbox" value="">`;
      },
      align: 'right',
      tdClass: { 'fz-sm': true },
    },
    {
      label: 'No',
      name: 'no',
      type: 'seq',
    },

    {
      label: 'ニックネーム',
      name: 'nickname',
    },
    {
      label: '保護者氏名',
      name: 'parent_full_name',
    },
    {
      label: '授業料(税込) *月内に変動がある時は平均',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return Number(row.lesson_amount).toLocaleString('ja-JP', {
          style: 'currency',
          currency: 'JPY',
        });
      },
      align: 'right',
      tdClass: { 'fz-sm': true },
    },

    {
      label: '当月授業回数',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `${Number(row.already_lesson_count)}`;
      },
      align: 'right',
      tdClass: { 'fz-sm': true },
    },

    {
      label: 'オプション料金合計',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `${Number(row.optional_amount).toLocaleString('ja-JP', {
          style: 'currency',
          currency: 'JPY',
        })}`;
      },
      align: 'right',
      tdClass: { 'fz-sm': true },
    },
    {
      label: '請求額(税込)',
      name: 'claimAmount',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return row.sum_lesson_amount.toLocaleString('ja-JP', {
          style: 'currency',
          currency: 'JPY',
        });
      },
      align: 'right',
      tdClass: { 'fz-lg': true },
    },

    {
      label: '請求実施',
      type: 'button',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r': true,
      },
      name: 'claimButton',
      onclick: (row: PaymentStudentDTO) => {
        return;
      },
      align: 'middle',
    },
  ];

  get totalAmount() {
    return this.rows.reduce((p, c) => p + c.sum_lesson_amount, 0);
  }

  get totalLessonCount() {
    return this.rows.reduce((p, c) => p + c.already_lesson_count, 0);
  }

  @Watch('target_month')
  async load() {
    // console.log(this.target_month);
    const target = this.target_month;
    // console.log('target', target);
    const biz = new PaymentStudentService();
    const result = await biz.getMonthlyPaymentStatus(target, Session.getSessionBuildingId());
    this.rows = result.data;
  }

  async exportCSV() {
    const url = `${URIs.CLAIM_CSV_DOWNLOAD.path}?month=${this.target_month}&building_id=${Session.getSessionBuildingId()}&token=${Session.getJwtToken()}`;
    location.href = url;
  }
  async exportKpCSV() {
    const url = `${URIs.CLAIM_KP_CSV_DOWNLOAD.path}?month=${this.target_month}&building_id=${Session.getSessionBuildingId()}&token=${Session.getJwtToken()}`;
    location.href = url;
  }

  prevMonth() {
    this.target_month = dayjs(this.target_month).add(-1, 'month').format(MONTH_FORMAT);
  }
  currentMonth() {
    this.target_month = dayjs().add(-1, 'month').format(MONTH_FORMAT);
  }

  async created() {
    this.load();
  }
}
